import { Check, ChevronRight } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { STATUS_LABELS, stageTypeLabel } from '../../../lib/stages';

export const StageStatusPill = ({ status }) => {
  if (status === 'active') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 border px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.2em]',
          'border-live/60 text-live'
        )}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-live animate-pulse-live motion-reduce:animate-none" />
        {STATUS_LABELS[status]}
      </span>
    );
  }
  if (status === 'completed') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 border px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.2em]',
          'border-border/60 text-foreground/70'
        )}
      >
        <Check className="h-3 w-3" />
        {STATUS_LABELS[status]}
      </span>
    );
  }
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 border px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.2em]',
        'border-border/60 text-muted-foreground'
      )}
    >
      {STATUS_LABELS[status]}
    </span>
  );
};

const StageStepper = ({ stages, selectedId, onSelect }) => (
  <ol className="flex items-stretch gap-2 overflow-x-auto pb-1">
    {stages.map((stage, i) => (
      <li key={stage.id} className="flex shrink-0 items-center gap-2">
        <button
          type="button"
          aria-current={stage.id === selectedId ? 'step' : undefined}
          onClick={() => onSelect(stage.id)}
          className={cn(
            'min-w-[11rem] rounded-md border px-3 py-2 text-left transition-colors',
            stage.id === selectedId
              ? 'border-heat/60 bg-heat/5'
              : 'border-border/60 hover:border-border'
          )}
        >
          <div className="flex items-center justify-between gap-2">
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              Stage {String(i + 1).padStart(2, '0')}
            </span>
            <StageStatusPill status={stage.status} />
          </div>
          <div className="mt-1 truncate font-display text-base font-semibold">{stage.name}</div>
          <div className="text-xs text-muted-foreground">{stageTypeLabel(stage)}</div>
        </button>
        {stages[i + 1] && (
          <div className="flex shrink-0 flex-col items-center font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            <ChevronRight className="h-4 w-4" />
            {Number.isInteger(stages[i + 1].advanceCount) && (
              <span>Top {stages[i + 1].advanceCount}</span>
            )}
          </div>
        )}
      </li>
    ))}
  </ol>
);

export default StageStepper;
